import { Injectable } from '@angular/core';
import { LinhaRota } from '@tivic-team/manager-ts/dist/mob/entities/linha/linha-rota.entity';
import { Linha } from '@tivic-team/manager-ts/dist/mob/entities/linha/linha.entity';
import { LinhaDTO, LinhaListDTO } from 'app/model/dtos/mob/linha.dto';
import { HttpGet, HttpPost, HttpPut, HttpResponse, JSONData, Quark, Url } from 'sol-request-angular/dist/comunicacao';
import { IFilter } from 'sol-request-angular/dist/comunicacao/interfaces/IFilter';
import { environment } from 'src/environments/environment';
import { environmentv3 } from 'src/environments/environmentv3';
import { TabelaHorarioRotaDTO } from '../../model/dtos/mob/tabela-horario-rota.dto';
import { TabelaHorarioDTO } from '../../model/dtos/mob/tabela-horario.dto';

@Injectable()
export class LinhaController {

	constructor() { }

    find(filters ? : IFilter): Promise <Linha[]> {
        let request = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/linhas/linha',
                    environment: environmentv3,
                    filter: filters,
                }),
            }),
            new HttpResponse(new Array<Linha> ())
        );

        return request.call();
    }

    findLinha(filters ? : IFilter): Promise <Linha[]> {
        let request = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/linhas',
                    environment: environmentv3,
                    filter: filters,
                }),
            }),
            new HttpResponse(new Array<Linha> ())
        );

        return request.call();
    }

	async findLinhas(filtros?: IFilter): Promise<LinhaListDTO> {
		let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'mob/linhas',
					environment: environment,
					filter: filtros
				}),
			}),
			new HttpResponse(
				new LinhaListDTO()
			)
		);
		return await quark.call();
	}
	
	get(id: number): Promise <LinhaDTO> {
        let request = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/linhas/:cdLinha',
                    environment: environmentv3,
                    pathParams: new JSONData({
                        cdLinha: id
                    }),
                }),
            }),
            new HttpResponse(new LinhaDTO())
    );

        return request.call();
    }

	create(entity: Linha): Promise <Linha> {
        let request = new Quark(
            new HttpPost({
                url: new Url({
                    id: 'mob/linhas',
                    environment: environmentv3
                }),
                data: new JSONData(entity)
            }),
            new HttpResponse(
                new Linha()
            )
        );

        return request.call();
    }

    update(entity: Linha): Promise <Linha> {
        let request = new Quark(
            new HttpPut({
                url: new Url({
                    id: 'mob/linhas/:cdLinha',
                    environment: environmentv3,
                    pathParams: new JSONData({
                        cdLinha: entity.cdLinha
                    })
                }),
                data: new JSONData(entity)
            }),
            new HttpResponse(
                new Linha()
            )
        );
        return request.call();
    }

    createLinhaRural(entity: Linha): Promise <Linha> {
        let request = new Quark(
            new HttpPost({
                url: new Url({
                    id: 'mob/linhas/coletivo-rural',
                    environment: environmentv3
                }),
                data: new JSONData(entity)
            }),
            new HttpResponse(
                new Linha()
            )
        );

        return request.call();
    }   

    updateLinhaRural(entity: Linha): Promise <Linha> {
        let request = new Quark(
            new HttpPut({
                url: new Url({
                    id: 'mob/linhas/coletivo-rural/:cdLinha',
                    environment: environmentv3,
                    pathParams: new JSONData({
                        cdLinha: entity.cdLinha
                    })
                }),
                data: new JSONData(entity)
            }),
            new HttpResponse(
                new Linha()
            )
        );
        return request.call();
    }
    
	async getRotas(cdLinha: number): Promise<LinhaRota[]> {
		let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'mob/linhas/:cdLinha/rotas',
					environment: environment,
					pathParams: new JSONData({
						cdLinha: cdLinha
					})
				}),
			}),
			new HttpResponse(
				new Array<LinhaRota>()
			)
		);
		return await quark.call();
	}

	async getTabelas(cdLinha: number, cdTabelaHorario:number): Promise<TabelaHorarioDTO> {
		let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'mob/linhas/:cdLinha/tabelas/:cdTabelaHorario',
					environment: environment,
					pathParams: new JSONData({
						cdLinha,
						cdTabelaHorario
					})
				}),
			}),
			new HttpResponse(
				new Array<TabelaHorarioRotaDTO>()
			)
		);
		return await quark.call();
	}

    getRelatorioItinerario(filtros?: IFilter): Promise<Blob> {
        let quark = new Quark(
          new HttpGet({
            url: new Url({
              id: 'mob/linhas/itinerarios',
              environment: environmentv3,
              filter: filtros
            }),
            responseType: 'Blob'
          }),
          new HttpResponse(
            new Blob
          )
        );
        return quark.call();
    }
}